import SecureChatInstance from "../components/secure-chat/secure-chat-instance";
import Config from "../config";
import { AxiosInstance } from "../helpers/AxiosInstance";

const getAllSecureChatConversations = (PhoneNumber: string) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/participants/latest/message/${PhoneNumber}`)
}

const getFalkonSecureChatHistory = (partcipantId: string, page: number) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/history/messages/${partcipantId}?p=${page}`)
}

const getSecureChatHistory = (partcipantId: string, page: number) => {
    return SecureChatInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/history/messages/${partcipantId}?p=${page}`)
}

const genearateSecureChatLink = (customerPhoneNumber: string, data: {
    organization_id: string,
    organization_name: string,
    falkon_user_number: string
}) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/send/link/${customerPhoneNumber}`, data);
}

const getPartcipantData = (partcipantId: string) => {
    return SecureChatInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/participant/id/${partcipantId}`)
}

const MarkAllMessagesAsRead = (PhoneNumber: string, fromPhonePhoneNumber: string) => {
    return AxiosInstance.patch(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/readAll/messages/${PhoneNumber}/${fromPhonePhoneNumber}`)
}

const MarkAllSecureChatParticipantMessagesAsRead = (PhoneNumber: string, fromPhonePhoneNumber: string, time: string) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/read/receipt/${PhoneNumber}/${fromPhonePhoneNumber}/${time}`)
}

const getSecureChatLoginStatus = (partcipantId: string) => {
    return SecureChatInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/login/${partcipantId}`)
}

const SendSecureChatOtp = (partcipantId: string) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/sendotp/${partcipantId}`)
}

const VerifySecureChatOtp = (partcipantId: string, data: { code: string }) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/verifyotp/${partcipantId}`, data)
}

const SetSecureChatPin = (partcipantId: string, data: {
    pin: string,
    temporaryKey: string
}) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/setpin/${partcipantId}`, data)
}

const LoginSecureChat = (data: { participantId: string, pin: string }) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/login`, data)
}
const HandleNotificationSounds = (
    participantId: string,
    data: {
        soundStatus: boolean
    }
) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/participant/sound/${participantId}`, data)
}

const createScheduleMessage = (partcipantId: string, data) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/schedule/${partcipantId}`, data)
}

const updateScheduleMessage = (scheduleId: string, data) => {
    return AxiosInstance.put(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/schedule/${scheduleId}`, data)
}

const deleteScheduleMessage = (scheduleId: string) => {
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/schedule/${scheduleId}`)
}

const getAllScheduleMessagesByPhoneNumber = (falkonNumber: string) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/schedule/${falkonNumber}`)
}

const archiveSecureChat = (id: string, isArchived: boolean) => {
    const data = {
        is_archived: isArchived
    }
    return AxiosInstance.put(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/archive/participant/${id}`, data)
}

const secureChatMediaDownloadLog = (data) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/media/download/log`, data)
}

const secureChatMediaDownloadLogEndUserSide = (data) => {
    return SecureChatInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/media/download/log`, data)
}

export const SecureChatService = {
    genearateSecureChatLink,
    getPartcipantData,
    getFalkonSecureChatHistory,
    getSecureChatHistory,
    getAllSecureChatConversations,
    MarkAllMessagesAsRead,
    MarkAllSecureChatParticipantMessagesAsRead,
    getSecureChatLoginStatus,
    SendSecureChatOtp,
    VerifySecureChatOtp,
    SetSecureChatPin,
    LoginSecureChat,
    HandleNotificationSounds,
    getAllScheduleMessagesByPhoneNumber,
    createScheduleMessage,
    updateScheduleMessage,
    deleteScheduleMessage,
    archiveSecureChat,
    secureChatMediaDownloadLog,
    secureChatMediaDownloadLogEndUserSide,
}